/*
  Tested url: http://127.0.0.1:9292/collections/fr-test-collection
*/
window.addEventListener("DOMContentLoaded", function () {
  var createCollapsibleDescription = function (fa_$) {
    /* 
      This applied on collection description for a collapsible content.
      The trick is borrowed from https://www.the-art-of-web.com/javascript/truncate-expand-text/
      hwei@wayout-tech.com 2022/10/19
      */
    fa_$(document).on("click", ".collapsible .toggler", function () {
      fa_$(this).parent().toggleClass("open");
    });

    fa_$(faConfig.collapsible_descClassName).each(function () {
      let container = fa_$(this);
      let section = container.children("section").first();
      if (section && section.length > 0) {
        container.addClass("collapsible");
        container.append(fa_$("<a href='#'></a>").addClass("toggler"));

        /* 
          For putting "more" button at the same line with the summary, the summary uses a inline element, e.g., span.
          That causes very small space between summary and collapsible description.

          To fix that, we detect if the summary is a inline tag, then we add a "p" for line break as the first child of the section.
        */
        let lastElBeforeSection = section.prevAll().last();
        if (lastElBeforeSection) {
          console.debug("The last element before section is ", lastElBeforeSection);
          if (lastElBeforeSection.css('display') === 'inline') {
            console.debug("Add a p tag as a line break after ", lastElBeforeSection);
            section.prepend(fa_$("<p id='insert-line-break'></p>"));
          }
        }
      }
    });
  };

  faLoadjQueryThenRun((fa_$) => {
    console.log(
      "This site is using jQuery version: " + fa_$.fn.jquery + " (figured-art.js)"
    );
    createCollapsibleDescription(fa_$);
    console.info("Activate collapsible description feature");
  });
});
